import React from 'react';
import HighSchoolPortfolioItems from './high-school-portfolio-items';
import TransferPortfolioItems from './transfer-portfolio-items';

interface Props {
  transfer: boolean;
}

const PortfolioItems = ({transfer}: Props) => (
  <div className="portfolio" id="portfolio-items-synthetic-hook">
    {transfer ? <TransferPortfolioItems /> : <HighSchoolPortfolioItems />}
  </div>
);

export default PortfolioItems;
